import { render, staticRenderFns } from "./BackgroundDetailView.vue?vue&type=template&id=7dbafefe&scoped=true&"
import script from "./BackgroundDetailView.vue?vue&type=script&lang=js&"
export * from "./BackgroundDetailView.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundDetailView.vue?vue&type=style&index=0&id=7dbafefe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbafefe",
  null
  
)

export default component.exports